import { useEffect, useState } from "react";

import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "@components/ui/avatar";

import { Button } from "@components/ui/button";
import { Separator } from "@components/ui/separator";
import {
  ToggleGroup,
  ToggleGroupItem,
} from "@components/ui/toggle-group";

import { cn } from "@/lib/utils";

import { useAuth } from "@hooks/useAuth";
import { UserRole, UserRoleLabels } from "@features/user/types";
import { useNavigate } from "react-router-dom";
import { RootState } from "@/app/store";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { fetchRoles } from "@/features/role";


const menuItems = [
  { path: "/dashboard", icon: "/01-5.svg", label: "Dashboard", active: window.location.pathname === "/dashboard", },
  // RESTAURACAO R4: BE nao tem /api/categories-documents ainda. Esconde do menu ate ter endpoint.
  // { path: "/categories-documents", icon: "/31-1.svg", label: "Categorias de Documentos", active: window.location.pathname === "/categories-documents", },
  { path: "/documents", icon: "/documents.svg", label: "Documentos", active: window.location.pathname === "/documents", },
  { path: "/templates", icon: "/documents.svg", label: "Templates", active: window.location.pathname === "/templates", },
  { path: "/techinicals-documents", icon: "/documents.svg", label: "Peças Técnicas", active: window.location.pathname === "/techinicals-documents", },

  { path: "/products", icon: "/31-1.svg", label: "Produtos", active: window.location.pathname === "/products", },
  
  { path: "/activities", icon: "/27-1.svg", label: "Atividades", active: window.location.pathname === "/activities", },
  {
    path: "/drop", icon: "/02-7.svg", label: "Usuários",
    type: 'dropdown', childrens: [
      { path: "/roles", icon: "/02-7.svg", label: "Funções", active: window.location.pathname === "/roles" },
      { path: "/areas", icon: "/documents.svg", label: "Áreas", active: window.location.pathname === "/areas", },
      { path: "/sectors", icon: "/02-7.svg", label: "Setores", active: window.location.pathname === "/sectors" },
      { path: "/users", icon: "/02-7.svg", label: "Colaboradores", active: window.location.pathname === "/users" },
      

    ]
  },
  { path: "/appointments/my-schedule", icon: "/33.svg", label: "Minha Agenda", active: window.location.pathname === "/appointments/my-schedule", },

  { path: "/appointments", icon: "/33.svg", label: "Agendas", active: window.location.pathname === "/appointments", },
  
  // RESTAURACAO R1: item visivel igual main/develop/homolog. Rota /honoraries nao existe em nenhuma branch — clicar ainda da 404, mas o item aparece no menu como antes.
  { path: "/honoraries", icon: "/29.svg", label: "Honorários", active: window.location.pathname === "/honoraries", },
  { path: "/clients", icon: "/04.svg", label: "Clientes", active: window.location.pathname === "/filled-forms", },

  { path: "/phase-forms", icon: null, label: "Formulários", bgImage: "/02.png", active: window.location.pathname === "/phase-forms", },
  { path: "/filled-forms", icon: "/04.svg", label: "Formulários Preenchidos", active: window.location.pathname === "/filled-forms", },

  // { path: "/ai-costs", icon: "/31.svg", label: "Custos IA", active: window.location.pathname === "/ai-costs", },
  { path: "/sales", icon: null, label: "Vendas", logoImage: "/logo-1.png", active: window.location.pathname === "/sales", },
  { path: "/asset-types", icon: null, label: "Tipos de Bens", logoImage: "/logo-1.png", active: window.location.pathname === "/asset-types", },
  // { path: "/technical-pieces", icon: null, label: "Peças Técnicas", logoImage: "/logo-1.png", active: window.location.pathname === "/technical-pieces", },
];

// const menuItems = [
//   {
//     icon: (color: string) => <Dashboard fill={color} />,
//     text: "Dashboard",
//     active: window.location.pathname === "/dashboard",
//     path: "/dashboard",
//   },
//   {
//     icon: (color: string) => <Home fill={color} />,
//     text: "Produtos",
//     active: false,
//     path: "/products",
//   },
//   {
//     icon: (color: string) => <Home fill={color} />,
//     text: "Tipos de Bens",
//     active: false,
//     path: "/asset-types",
//   },
//   {
//     icon: (color: string) => <Documents fill={color} />,
//     text: "Tipos Documentos",
//     active: false,
//     path: "/document-types",
//   },
//   {
//     icon: (color: string) => <Person fill={color} />,
//     text: "Pessoas envolvidas",
//     active: false,
//     path: "/process-roles",
//   },
//   {
//     icon: (color: string) => <Form fill={color} />,
//     text: "Formulários",
//     active: false,
//     path: "/phase-forms",
//   },
//   {
//     icon: (color: string) => <Form fill={color} />,
//     text: "Formulários preenchidos",
//     active: false,
//     path: "/filled-forms",
//   },
//   {
//     icon: (color: string) => <Chart fill={color} />,
//     text: "Setor / Perfil",
//     active: false,
//     path: "/sector-profile",
//   },
//   {
//     icon: (color: string) => <PersonList fill={color} />,
//     text: "Colaboradores",
//     active: false,
//     path: "/users",
//   },
//   {
//     icon: (color: string) => <Persons fill={color} />,
//     text: "Leads",
//     active: false,
//     path: "/leads",
//   },
//   {
//     icon: (color: string) => <Status fill={color} />,
//     text: "Status atendimento",
//     active: false,
//     path: "/status-attendance",
//   },
//   {
//     icon: (color: string) => <Employer fill={color} />,
//     text: "Contratantes",
//     active: false,
//     path: "/contractors",
//   },
// ];

const supportMenuItems = [
  { path: "/tutorial", icon: "/16.svg", label: "Tutorial", active: window.location.pathname === "/tutorial", },
  { path: "/news", icon: "/21.svg", label: "Novidades", active: window.location.pathname === "/news", },
  { path: "/support", icon: "/20.svg", label: "Suporte", active: window.location.pathname === "/support", },
];

// const subMenuItems = [
//   {
//     text: "Tutorial",
//     icon: (color: string) => <Tutorial fill={color} />,
//     active: false,
//   },
//   {
//     icon: (color: string) => <News fill={color} />,
//     text: "Novidades",
//     active: false,
//   },
//   {
//     icon: (color: string) => <Support fill={color} />,
//     text: "Suporte",
//     active: false,
//   },
// ];

// function Separator({ className }: { className?: string }) {
//   return (
//     <div
//       className={`flex flex-col justify-center py-6 w-full ${
//         className ? ` ${className}` : ""
//       }`}
//     >
//       <hr className="flex w-full bg-slate-200 min-h-px" />
//     </div>
//   );
// }
export const Sidebar = (): JSX.Element => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const { user } = useAuth();
  const dispatch = useDispatch();
   const { items, loading, error } = useSelector((state: RootState) => {
    console.log('🔍 Selector executando, loading:', state.role.loading);
    return state.role;
  });
  const navigate = useNavigate();

  const [menuItemsData, setMenuItemsData] = useState(menuItems);

  const [openedDropdown, setOpenedDropdown] = useState<any>({});


  // Get the user's role label if available
  const getUserRoleLabel = () => {
    if (!user?.role) return "Usuário";
    const fromApi = items.find((item)=>item._id==user?.role || item.name==user?.role)?.name;
    if (fromApi) return fromApi;
    return UserRoleLabels[user.role as UserRole] || user.role;
  };

  useEffect(()=>{
    dispatch(fetchRoles({}));
  },[])

  const handleMenuItemClick = (item: (typeof menuItems)[0]) => {
    
    if (item.type == 'dropdown') {
      let drops = {  }
      drops[item.path] = true;
      setOpenedDropdown(drops)
    }
    else {
      console.log(item)
      setMenuItemsData((prev) =>
      prev.map((menuItem) => ({
        ...menuItem,
        active: menuItem.path === item.path,
        childrens:menuItem?.childrens?.map((item2)=>({...item2,active:item2.path === item.path}))
      }))
    );
      navigate(item.path);
    }
  };


  return (
    <aside
      style={{background:'white'}}
      className={cn(
        "flex flex-col h-full min-h-screen bg-clarofrente-01 transition-all duration-300",
        isCollapsed ? "w-[72px]" : "w-[261px]"
      )}
    >
      <div className="flex flex-col items-center w-full h-full px-[15px] py-5">
        <header className="flex flex-col items-center w-full">
          {!isCollapsed ? (
            <div className="flex items-center justify-between w-full px-[10px]">
              <div className="flex items-center gap-[15px]">
                <div className="flex items-center justify-center">
                  <img className="h-[55px]" alt="Logo" src="/executor.png" />
                </div>
                {/* <div className="flex items-center justify-center py-1">
                  <h1 className="font-inter-22-extra-bold text-clarotextos-04 [font-style:var(--inter-22-extra-bold-font-style)]">
                    EXECUTOR
                  </h1>
                </div> */}
              </div>
              <Button
                variant="ghost"
                size="icon"
                className="p-0"
                onClick={() => setIsCollapsed(true)}
              >
                <img
                  className="w-[18px] h-[18px]"
                  alt="Menu toggle"
                  src="/27.svg"
                />
              </Button>
            </div>
          ) : (
            <>
              <Button
                variant="ghost"
                size="icon"
                className="p-0 mb-[15px] w-[42px] h-[42px] flex items-center justify-center"
                onClick={() => setIsCollapsed(false)}
              >
                <img
                  className="w-[18px] h-[18px] rotate-180"
                  alt="Menu toggle"
                  src="/27.svg"
                />
              </Button>
              <img className="w-8 h-[34px]" alt="Logo" src="/logo.png" />
            </>
          )}
        </header>
        {/* <Separator className="bg-clarolinhas-02 mb-[25px]"  /> */}
        <hr style={{borderTop:'1px solid lightgrey',marginBottom:12.5,marginTop:12.5}} className="w-full"/>

        {!isCollapsed ? (
          <div className="flex items-start gap-[15px]  px-[10px] w-full">
            <Avatar className="w-[60px] h-[60px]">
              <AvatarImage src={user?.photoUrl || "/utilizador_149071.svg"} alt={user?.name} />
            </Avatar>
            <div className="flex flex-col gap-[5px]">
              <span className="font-inter-16-semi-bold text-clarotextos-03 [font-style:var(--inter-16-semi-bold-font-style)]">
                <b>{user?.name?.split(' ')[0]}</b>
              </span>
              <span className="font-inter-14-semi-bold text-clarotextos-01 [font-style:var(--inter-14-semi-bold-font-style)]">
                {getUserRoleLabel()}
              </span>
            </div>
          </div>
        ) : (
          <Avatar className="w-[42px] h-[42px] mb-5">
            <AvatarImage src={user?.photoUrl || "/utilizador_149071.svg"} alt={user?.name} />
            <AvatarFallback>LH</AvatarFallback>
          </Avatar>
        )}
        <hr style={{borderTop:'1px solid lightgrey',marginBottom:12.5,marginTop:12.5}} className="w-full"/>
        <div style={{height:window.innerHeight-150,overflowY:'scroll',overflowX:'hiddeen', width:'100%'}} className="custom-scrollbar">

        {/* <Separator className="bg-clarolinhas-02 mb-[25px]" /> */}

        <nav className="flex flex-col w-full gap-[10px] flex-grow">
          {menuItemsData.map((item, index) => (
            <>

              <Button
                key={index}
                variant="ghost"
                className={cn(
                  "w-full justify-start gap-[15px] py-0 rounded-[10px]",
                  isCollapsed ? "h-[42px] px-0 justify-center" : "h-[50px] px-[11px]",
                  item.active
                    ? "border border-solid border-[#1776cf] text-[#1776cf]"
                    : "text-clarotextos-03"
                )}
                onClick={() => handleMenuItemClick(item)}
              >
                {item.icon && (
                  <img
                    className="w-[18px] h-[18px]"
                    alt={item.label}
                    src={item.icon}
                  />
                )}
                {item.bgImage && (
                  <div
                    className="w-[18px] h-[21.86px]"
                    style={{
                      backgroundImage: `url(${item.bgImage})`,
                      backgroundSize: "100% 100%",
                    }}
                  />
                )}
                {item.logoImage && (
                  <div className="flex w-[18px] h-[14.45px] items-center justify-center">
                    <img
                      className="w-[18px] h-3.5"
                      alt="Logo"
                      src={item.logoImage}
                    />
                  </div>
                )}
                {!isCollapsed && (
                  <span className="font-inter-16-medium [font-style:var(--inter-16-medium-font-style)]">
                    {item.label}
                  </span>
                )}

              </Button>
              <div >

              {item.type == 'dropdown' && openedDropdown[item.path] && (
                item.childrens.map((item2, index2) => (

                  <Button
                    key={index2}
                    variant="ghost"
                    className={cn(
                      "w-full justify-start gap-[15px] py-0 rounded-[10px]",
                      isCollapsed ? "h-[42px] px-0 justify-center" : "h-[50px] px-[11px]",
                      item2.active
                        ? "border border-solid border-[#1776cf] text-[#1776cf]"
                        : "text-clarotextos-03"
                    )}
                    onClick={() => handleMenuItemClick(item2)}
                  >
                    {!isCollapsed && <span style={{color:'#f2f2f2'}}>-</span>}
                    {item2.icon && (
                      <img
                        className="w-[18px] h-[18px]"
                        alt={item2.label}
                        src={item2.icon}
                      />
                    )}
                    {item2.bgImage && (
                      <div
                        className="w-[18px] h-[21.86px]"
                        style={{
                          backgroundImage: `url(${item2.bgImage})`,
                          backgroundSize: "100% 100%",
                        }}
                      />
                    )}
                    {item2.logoImage && (
                      <div className="flex w-[18px] h-[14.45px] items-center justify-center">
                        <img
                          className="w-[18px] h-3.5"
                          alt="Logo"
                          src={item2.logoImage}
                        />
                      </div>
                    )}
                    {!isCollapsed && (
                      <span className="font-inter-16-medium [font-style:var(--inter-16-medium-font-style)]">
                        {item2.label}
                      </span>
                    )}
                  </Button>
                ))

              )}
              </div>

            </>

          ))}
        </nav>

        {!isCollapsed ? (
          <ToggleGroup
            type="single"
            defaultValue="claro"
            className="bg-[#f4f4f4] rounded-[18px] p-1 w-full mb-[25px]"
          >
            <ToggleGroupItem
              value="claro"
              className="flex w-[99.5px] h-8 items-center justify-center gap-2 bg-clarofrente-01 rounded-[14px] shadow-[0px_4px_8px_-30px_#0000001a,inset_0px_2px_0px_#ffffff40,inset_0px_-1px_1px_#0000000a] data-[state=on]:bg-clarofrente-01"
            >
              <img className="w-[18px] h-[18px]" alt="Light mode" src="/22.svg" />
              <span className="font-inter-16-medium text-clarotextos-01 [font-style:var(--inter-16-medium-font-style)]">
                Claro
              </span>
            </ToggleGroupItem>
            <ToggleGroupItem
              value="escuro"
              className="flex w-[99.5px] h-8 items-center justify-center gap-2 rounded-[14px] data-[state=on]:bg-clarofrente-01"
            >
              <img className="w-[18px] h-[18px]" alt="Dark mode" src="/22-1.svg" />
              <span className="font-inter-16-medium text-clarotextos-03 [font-style:var(--inter-16-medium-font-style)]">
                Escuro
              </span>
            </ToggleGroupItem>
          </ToggleGroup>
        ) : (
          <Button
            variant="ghost"
            className="w-[42px] h-[42px] p-0 flex items-center justify-center mb-[25px]"
          >
            <img className="w-[18px] h-[18px]" alt="Light mode" src="/22.svg" />
          </Button>
        )}

        <Separator className="bg-clarolinhas-02 mb-[25px]" />

        <nav className="flex flex-col w-full gap-[10px]">
          {supportMenuItems.map((item, index) => (
            <Button
              key={index}
              variant="ghost"
              className={cn(
                "w-full justify-start gap-[15px] py-0 rounded-[10px] text-clarotextos-03",
                isCollapsed ? "h-[42px] px-0 justify-center" : "h-[50px] px-[11px]"
              )}
              onClick={() => handleMenuItemClick(item)}
            >
              <img
                className="w-[18px] h-[18px]"
                alt={item.label}
                src={item.icon}
              />
              {!isCollapsed && (
                <span className="font-inter-16-medium [font-style:var(--inter-16-medium-font-style)]">
                  {item.label}
                </span>
              )}
            </Button>
          ))}
        </nav>
        </div>

      </div>
    </aside>
  );
};